import { themeLss } from "../../lss";
import styled from "../../styled";
export var Box = styled.div(themeLss());
/**
 * You should use the Flex component when you want to apply specific rules from Flexbox to its children, such as align-items and justify-content.
 *
 * For more information about Flexbox: https://css-tricks.com/snippets/css/a-guide-to-flexbox/
 */
export var Flex = styled(Box)({
    display: 'flex'
});
//# sourceMappingURL=Box.js.map